import { prettyMilliseconds } from "@-/com.npmjs.pretty-ms";
import type { SeatClass, TransportMode } from "#resolve-travel-options";

export const TRANSPORT_MODE_LABELS: Record<TransportMode, string> = {
  bus: "Coach",
  flight: "Flight",
  hsr: "High-speed rail",
  metro: "Metro",
  rail: "Train",
};

export const TRANSPORT_MODE_ICONS: Record<TransportMode | "dragon" | "start" | "teleport", string> =
  {
    bus: "🚌",
    dragon: "龙",
    flight: "✈️",
    hsr: "🚄",
    metro: "🚇",
    rail: "🚂",
    start: "📍",
    teleport: "✨",
  };

export const SEAT_CLASS_LABELS: Record<SeatClass, string> = {
  economy: "Economy",
  "hard-seat": "Hard seat",
  "hard-sleeper": "Hard sleeper",
  second: "Second class",
  standard: "Standard",
};

/** `4h 48m`, `35m`, `2d 3h`. */
export function formatTravelDuration(totalMinutes: number): string {
  return prettyMilliseconds(Math.max(0, Math.round(totalMinutes)) * 60_000, {
    hideSeconds: true,
    unitCount: 2,
  });
}

/** `¥553`, `¥156.5`. */
export function formatYuan(fareCny: number): string {
  return `¥${Number.isInteger(fareCny) ? fareCny : fareCny.toFixed(1)}`;
}
